import { Component, Input, OnInit } from '@angular/core';

import { Property, PropertySet } from '@mirage-projects/cw-models';
import { DbPcvizService } from '@mirage-projects/cw-pcviz-core';

import { PropertyBagService } from '../property-bag.service';
@Component({
    selector: 'cw-property-color',
    templateUrl: './property-color.component.html',
    standalone: false,
})
export class PropertyColorComponent implements OnInit {
    /** This object comes from the core and provides methods to obtain and set the value of the properties */
    @Input() propertySet!: PropertySet;

    /** Input field with the required information for this field type */
    @Input() property!: Property;

    color: number[] = [];
    label = '';

    constructor(
        private propertyBagService: PropertyBagService,
        private dbPcvizService: DbPcvizService
    ) {}

    ngOnInit(): void {
        this.label = this.propertyBagService.getCorrectLabel(this.property);

        const colorHex = this.propertyBagService.getValueProperty(this.propertySet, this.property);
        if (!colorHex) {
            this.color = [0, 0, 0];
            return;
        }

        const colorRGB = this.dbPcvizService.getUtils().hexToRgb(colorHex);
        this.color = [colorRGB.r, colorRGB.g, colorRGB.b];
    }

    colorChange(valueColor: number[]): void {
        const colorAux = valueColor.map((element) => element / 255);
        const colorHex = this.dbPcvizService.getUtils().RgbTofullhex(colorAux);
        this.property.value = colorHex;
        this.propertyBagService.setValueProperty(this.propertySet, this.property);
    }
}
